import { render, staticRenderFns } from "./check-record.vue?vue&type=template&id=38c77998&scoped=true"
import script from "./check-record.vue?vue&type=script&lang=js"
export * from "./check-record.vue?vue&type=script&lang=js"
import style0 from "./check-record.vue?vue&type=style&index=0&id=38c77998&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c77998",
  null
  
)

export default component.exports